var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileDocRegular = function SvgFileDocRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA1AF",
    d: "m10 1.667.098.006a.83.83 0 0 1 .73.73l.006.097v3.334l.004.125a1.67 1.67 0 0 0 1.532 1.536l.13.005h3.334l.098.006a.83.83 0 0 1 .73.73l.005.098v7.5a2.5 2.5 0 0 1-2.353 2.496l-.147.004H5.834a2.5 2.5 0 0 1-2.496-2.354l-.004-.146V4.167a2.5 2.5 0 0 1 2.353-2.496l.147-.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA1AF",
    d: "M15.833 5.833H12.5L12.499 2.5z"
  })));
};
export default SvgFileDocRegular;